<portal-sub-nav route="enterprise-call-center-queue">
  <div [class.d-none]="loading$ | async">
    @if (viewModel$ | async; as context) {
      <portal-menu-context
        [description]="context.queue.description"
        [heading]="'menu.context.callCenter' | portalTranslate"
      >
        <ng-template>
          <portal-call-center-queue-switcher
            [callCenterId]="context.callCenter.id"
            [queue]="context.queue"
            [queues]="context.queues"
          ></portal-call-center-queue-switcher>
        </ng-template>
      </portal-menu-context>
      <!-- Agents -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-agents"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.agentsSupervisors' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Assigned Numbers -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-assigned-numbers"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.queue.assignedNumbers' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Route Config -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-route-config"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.queue.routing' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Settings -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-settings"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.settings' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Announcements -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-announcements"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.announcements' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Voice Mail -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-voice-mail"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.queue.voiceMail' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Call Recording -->
      @if (context.pcrAvailable === true || context.pcrEnabled === true) {
        <portal-sub-nav-item
          [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
          route="enterprise-call-center-queue-call-recording"
        >
          <ng-template portalTransclude>
            <span>{{ 'menu.callCenter.queue.callRecording' | portalTranslate }}</span>
          </ng-template>
        </portal-sub-nav-item>
      }
      <!-- Call Log -->
      <portal-sub-nav-item
        [params]="{ callCenterId: context.callCenter.id, queueId: context.queue.id }"
        route="enterprise-call-center-queue-call-log"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.callCenter.queue.callLog' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
    }
  </div>

  @if (loading$ | async) {
    <portal-menu-loading-indicator [withContext]="true"></portal-menu-loading-indicator>
  }
</portal-sub-nav>
